import React from 'react';
import Select from '../Select/Select';

const options = [
  { label: 'All', value: '' },
  { label: 'Active', value: 'false' },
  { label: 'Archived', value: 'true' },
];

const StatusSelect = ({ value = '', onChange, placeholder = 'Select Status', className }) => {
  const handleChange = (selected) => {
    // React-Select style: selected may be the option object
    const val = selected && selected.value ? selected.value : '';
    onChange && onChange(val, selected);
  };

  const selectedOption = options.find((o) => o.value === value) || options[0];

  return (
    <div className={className}>
      <Select
        options={options}
        value={selectedOption}
        onChange={handleChange}
        placeholder={placeholder}
      />
    </div>
  );
};

export default StatusSelect;
